import { lazy } from "react";
import RenderSubSection from "./RenderSubSections";

const CpcInvoicesDetail = lazy(
    () => import("pages/Invoice/CpcInvoices/showInvoiceDetail")
);
const OfflineInvoicesDetail = lazy(
    () =>
        import(
            "pages/Invoice/CpcInvoices/showInvoiceDetail/ShowInvoiceDetailOffline"
        )
);
const CpcInvoices = lazy(() => import("pages/Invoice/CpcInvoices/index"));
const TaxInvoices = lazy(() => import("pages/Invoice/TaxInvoices/InvoiceList"));
const TaxInvoicesDetail = lazy(
    () => import("pages/Invoice/TaxInvoices/InvoiceCreator")
);
const OfflineSellInvoiceList = lazy(
    () => import("pages/Invoice/OfflineSell/List")
);
const AddOfflineSellInvoiceList = lazy(
    () => import("pages/Invoice/OfflineSell/Add")
);
const OfflineCustomerForm = lazy(
    () => import("pages/Invoice/OfflineCustomer/Form")
);
const OfflineCustomerList = lazy(
    () => import("pages/Invoice/OfflineCustomer/List")
);

const CustomerList = {
    name: "لیست مشتریان",
    path: "/customer-list",
    group: "customer-list",
    exact: true,
    component: () => <OfflineCustomerList />,
};

const CustomerCreateForm = {
    name: "ثبت مشتری جدید",
    path: "/new-customer",
    group: "new-customer",
    isHide: true,
    component: () => <OfflineCustomerForm />,
};

const CustomerUpdateForm = {
    name: "به روزرسانی مشتری",
    path: "/update-customer/:id",
    group: "update-customer",
    isHide: true,
    component: () => <OfflineCustomerForm />,
};

const CustomerViewForm = {
    name: "مشاهده مشتری",
    path: "/update-customer/:id",
    group: "update-customer",
    isHide: true,
    component: () => <OfflineCustomerForm />,
};

const cpcInvoiceList = {
    name: "لیست فاکتور CPC",
    path: "/cpc-invoice-list",
    group: "cpc-invoice-list",
    exact: true,
    component: () => <CpcInvoices />,
};

const cpcInvoicesDetail = {
    name: "جزئیات فاکتور cpc",
    path: "/cpc-invoice-detail/:id",
    group: "cpc-invoice-detail",
    isHide: true,
    component: () => <CpcInvoicesDetail />,
};

const taxInvoiceList = {
    name: "لیست فاکتور مالیاتی",
    path: "/tax-invoice-list",
    group: "tax-invoice-list",
    exact: true,
    component: () => <TaxInvoices />,
};

const taxInvoicesDetail = {
    name: "جزئیات فاکتور مالیاتی",
    path: "/tax-invoice-detail/:id",
    group: "tax-invoice-detail",
    isHide: true,
    component: () => <TaxInvoicesDetail />,
};

const offlineInvoice = {
    name: "مشاهده فاکتور آفلاین",
    path: "/update-offline-invoice/:id",
    group: "update-offline-invoice",
    isHide: true,
    component: () => <AddOfflineSellInvoiceList />,
};

const offlineInvoiceList = {
    name: "لیست فاکتور آفلاین",
    path: "/list-offline-invoice",
    group: "list-offline-invoice",
    exact: true,
    component: () => <OfflineSellInvoiceList />,
};

const offlineInvoiceCreate = {
    name: "افزودن فاکتور آفلاین",
    path: "/add-offline-invoice",
    group: "add-offline-invoice",
    isHide: true,
    component: () => <AddOfflineSellInvoiceList />,
};

const offlineInvoicesDetail = {
    name: "جزئیات فاکتور آفلاین",
    path: "/offline-invoice-detail/:id",
    group: "offline-invoice-detail",
    isHide: true,
    component: () => <OfflineInvoicesDetail />,
};

const subSections = {
    customer: {
        list: { ...CustomerList },
        create: { ...CustomerCreateForm },
        update: { ...CustomerUpdateForm },
        view: { ...CustomerViewForm },
    },
    offline: {
        list: { ...offlineInvoiceList },
        create: { ...offlineInvoiceCreate },
        update: { ...offlineInvoice },
        //view: { ...offlineInvoice },
        view: { ...offlineInvoicesDetail },
    },
    cpc: {
        list: { ...cpcInvoiceList },
        create: { ...cpcInvoicesDetail },
        update: { ...cpcInvoicesDetail },
        view: { ...cpcInvoicesDetail },
    },
    tax: {
        list: { ...taxInvoiceList },
        create: { ...taxInvoicesDetail },
        update: { ...taxInvoicesDetail },
        view: { ...taxInvoicesDetail },
    },
};

const invoiceSection = {
    title: "فاکتور رسمی",
    key: "invoice",
    SubRoutes: (keywords: any) => RenderSubSection(keywords, subSections),
};

export default invoiceSection;
